<template>
  <div class="copyright-container" :class="{ 'copyright-container--compact': compact }">
    <div class="copyright-text">
      <span class="copyright-line">Copyright © {{ year }} {{ siteMeta.domain }}</span>
      <span class="copyright-line copyright-line--company">{{ siteMeta.company }} 版权所有</span>
    </div>
    <a class="copyright-icp" :href="siteMeta.icpUrl" target="_blank" rel="noopener noreferrer">
      {{ siteMeta.icp }}
    </a>
  </div>
</template>

<script>
import { SITE_META, getCopyrightYear } from '@/config/siteFooter'
import { isCompactViewport } from '@/utils/browser'

export default {
  name: 'CopyRight',
  data() {
    return {
      siteMeta: SITE_META,
      year: getCopyrightYear(),
      compact: isCompactViewport()
    }
  },
  mounted() {
    this.onResize = () => {
      this.compact = isCompactViewport()
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize)
    }
  }
}
</script>

<style scoped>
.copyright-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 13px;
  background-color: #252b29;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.copyright-text {
  margin: 0;
  flex: 1;
  line-height: 1.5;
}

.copyright-line {
  display: inline;
}

.copyright-line--company::before {
  content: ' · ';
}

.copyright-line--company {
  display: inline;
}

.copyright-icp {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: color 0.2s;
}

.copyright-icp:hover {
  color: #42b983;
}

.copyright-container--compact {
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 10px 12px 12px;
  font-size: 11px;
}

.copyright-container--compact .copyright-text {
  flex: none;
  line-height: 1.45;
}

.copyright-container--compact .copyright-line,
.copyright-container--compact .copyright-line--company {
  display: block;
}

.copyright-container--compact .copyright-line--company::before {
  content: none;
}

@media (max-width: 767px) {
  .copyright-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
    font-size: 11px;
  }

  .copyright-text {
    flex: none;
  }

  .copyright-line,
  .copyright-line--company {
    display: block;
  }

  .copyright-line--company::before {
    content: none;
  }
}
</style>
